'use client';

import { useEffect } from 'react';

const USERWAY_SCRIPT_ID = 'userway-widget-script';
const USERWAY_SRC = 'https://cdn.userway.org/widget.js';

function scheduleWhenPageSettles(callback: () => void) {
  const run = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 2_000 });
      return;
    }

    globalThis.setTimeout(callback, 1_500);
  };

  if (document.readyState === 'complete') {
    run();
    return;
  }

  window.addEventListener('load', run, { once: true });
}

export default function UserwayScript() {
  useEffect(() => {
    if (document.getElementById(USERWAY_SCRIPT_ID)) {
      return;
    }

    scheduleWhenPageSettles(() => {
      if (document.getElementById(USERWAY_SCRIPT_ID)) {
        return;
      }

      const script = document.createElement('script');
      script.id = USERWAY_SCRIPT_ID;
      script.src = USERWAY_SRC;
      script.async = true;
      script.setAttribute('data-account', '3aJTklQSHh');
      document.head.append(script);
    });
  }, []);

  return null;
}
